module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat4@3x-f740f6420929bfef91df17be318bd64c.jpg";